package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.ResetOutline: ImageVector
    get() {
        if (_resetOutline != null) {
            return _resetOutline!!
        }
        _resetOutline = Builder(name = "ResetOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 12.0f, viewportHeight = 12.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(5.5426f, 11.0833f)
                curveTo(4.7762f, 11.0833f, 4.0568f, 10.9386f, 3.3844f, 10.6492f)
                curveTo(2.7121f, 10.3597f, 2.1258f, 9.966f, 1.6257f, 9.468f)
                curveTo(1.1255f, 8.9699f, 0.7295f, 8.3843f, 0.4377f, 7.711f)
                curveTo(0.1459f, 7.0377f, 0.0f, 6.3184f, 0.0f, 5.5529f)
                horizontalLineTo(0.875f)
                curveTo(0.875f, 6.1945f, 0.9974f, 6.7988f, 1.2424f, 7.3657f)
                curveTo(1.4873f, 7.9326f, 1.8212f, 8.4275f, 2.2441f, 8.8504f)
                curveTo(2.667f, 9.2733f, 3.1623f, 9.6078f, 3.7298f, 9.8538f)
                curveTo(4.2974f, 10.0999f, 4.9013f, 10.2229f, 5.5416f, 10.2229f)
                curveTo(6.8444f, 10.2229f, 7.9479f, 9.7708f, 8.8521f, 8.8666f)
                curveTo(9.7562f, 7.9625f, 10.2083f, 6.859f, 10.2083f, 5.5562f)
                curveTo(10.2083f, 4.2534f, 9.7562f, 3.15f, 8.8521f, 2.2458f)
                curveTo(7.9479f, 1.3417f, 6.8444f, 0.8896f, 5.5416f, 0.8896f)
                curveTo(4.6352f, 0.8896f, 3.8184f, 1.1197f, 3.0911f, 1.58f)
                curveTo(2.3638f, 2.0403f, 1.8053f, 2.6467f, 1.4157f, 3.399f)
                horizontalLineTo(3.1073f)
                verticalLineTo(4.274f)
                horizontalLineTo(0.0f)
                verticalLineTo(1.1667f)
                horizontalLineTo(0.875f)
                verticalLineTo(2.6194f)
                curveTo(1.3536f, 1.8312f, 2.0011f, 1.1975f, 2.8174f, 0.7185f)
                curveTo(3.6337f, 0.2395f, 4.5417f, 0.0f, 5.5416f, 0.0f)
                curveTo(6.3082f, 0.0f, 7.0286f, 0.1454f, 7.7029f, 0.4363f)
                curveTo(8.3771f, 0.7272f, 8.9636f, 1.122f, 9.4624f, 1.6207f)
                curveTo(9.9611f, 2.1193f, 10.3559f, 2.7057f, 10.6469f, 3.3798f)
                curveTo(10.9378f, 4.0539f, 11.0833f, 4.7742f, 11.0833f, 5.5407f)
                curveTo(11.0833f, 6.3071f, 10.9378f, 7.0276f, 10.647f, 7.702f)
                curveTo(10.3561f, 8.3764f, 9.9613f, 8.963f, 9.4626f, 9.4619f)
                curveTo(8.964f, 9.9608f, 8.3776f, 10.3558f, 7.7035f, 10.6468f)
                curveTo(7.0294f, 10.9378f, 6.3091f, 11.0833f, 5.5426f, 11.0833f)
                close()
                moveTo(4.375f, 7.8077f)
                curveTo(4.2192f, 7.8077f, 4.0887f, 7.755f, 3.9833f, 7.6496f)
                curveTo(3.878f, 7.5443f, 3.8253f, 7.4137f, 3.8253f, 7.258f)
                verticalLineTo(5.508f)
                curveTo(3.8253f, 5.3523f, 3.8812f, 5.2217f, 3.993f, 5.1163f)
                curveTo(4.1048f, 5.011f, 4.2434f, 4.9583f, 4.4086f, 4.9583f)
                verticalLineTo(4.3413f)
                curveTo(4.4086f, 4.0297f, 4.5191f, 3.763f, 4.7401f, 3.5411f)
                curveTo(4.9611f, 3.3193f, 5.2283f, 3.2083f, 5.5416f, 3.2083f)
                curveTo(5.855f, 3.2083f, 6.1222f, 3.3193f, 6.3432f, 3.5411f)
                curveTo(6.5642f, 3.763f, 6.6747f, 4.0297f, 6.6747f, 4.3413f)
                verticalLineTo(4.9583f)
                curveTo(6.8399f, 4.9583f, 6.9785f, 5.011f, 7.0903f, 5.1163f)
                curveTo(7.2021f, 5.2217f, 7.258f, 5.3523f, 7.258f, 5.508f)
                verticalLineTo(7.258f)
                curveTo(7.258f, 7.4137f, 7.2053f, 7.5443f, 7.1f, 7.6496f)
                curveTo(6.9946f, 7.755f, 6.864f, 7.8077f, 6.7083f, 7.8077f)
                horizontalLineTo(4.375f)
                close()
                moveTo(4.9247f, 4.9583f)
                horizontalLineTo(6.1586f)
                verticalLineTo(4.3435f)
                curveTo(6.1586f, 4.1693f, 6.099f, 4.0225f, 5.9797f, 3.9033f)
                curveTo(5.8604f, 3.784f, 5.7144f, 3.7243f, 5.5416f, 3.7243f)
                curveTo(5.3689f, 3.7243f, 5.2229f, 3.784f, 5.1036f, 3.9033f)
                curveTo(4.9843f, 4.0225f, 4.9247f, 4.1693f, 4.9247f, 4.3435f)
                verticalLineTo(4.9583f)
                close()
            }
        }
        .build()
        return _resetOutline!!
    }

private var _resetOutline: ImageVector? = null
